import apiClient from './api';
import { validateRequiredParams } from '@/utils/apiUtils';
import {
  Top5PostsResponse,
  Bottom5PostsResponse,
  Top5PostsParams,
  Bottom5PostsParams,
  AiScatterResponse,
  AiScatterParams,
} from '@/types/aiMeasurement.types';

export const getTop5Posts = async (params: Top5PostsParams): Promise<Top5PostsResponse> => {
  validateRequiredParams(params, ['tenant_code']);

  const { tenant_code, ...queryParams } = params;

  const response = await apiClient.get<Top5PostsResponse>(
    `/ai-measurement/${encodeURIComponent(tenant_code)}/top-posts`,
    { params: queryParams }
  );

  return response.data;
};

export const getBottom5Posts = async (
  params: Bottom5PostsParams
): Promise<Bottom5PostsResponse> => {
  validateRequiredParams(params, ['tenant_code']);

  const { tenant_code, ...queryParams } = params;

  const response = await apiClient.get<Bottom5PostsResponse>(
    `/ai-measurement/${encodeURIComponent(tenant_code)}/bottom-posts`,
    { params: queryParams }
  );

  return response.data;
};

export const getCreativeVsMediaScatterPlot = async (
  params: AiScatterParams
): Promise<AiScatterResponse> => {
  validateRequiredParams(params, ['tenant_code']);

  const { tenant_code, ...queryParams } = params;

  const response = await apiClient.get<AiScatterResponse>(
    `/ai-measurement/${encodeURIComponent(tenant_code)}/scatter-plot`,
    { params: queryParams }
  );

  return response.data;
};
